import {useParams} from 'react-router';

import {skipToken} from '@reduxjs/toolkit/query';

import {and} from '@edna/utils';

import {useGetSupportClientQuery} from 'src/containers/SupportClients/api';
import {
  EFeatureFlag,
  EPaymentType,
  EPermission,
  EResellerIds,
  useFeatureFlag,
  useGetTenantDataQuery,
  usePermission,
} from 'src/containers/User';

const useStripeAutopaymentEnabled = () => {
  const {id: supportTenantId} = useParams<'id'>();
  const [hasFeatureFlag] = useFeatureFlag(EFeatureFlag.STRIPE_AUTOPAYMENT);

  const {data: supportClient} = useGetSupportClientQuery(supportTenantId ?? skipToken);
  const {data: tenantData} = useGetTenantDataQuery();

  const isPrePaymentType = supportTenantId
    ? supportClient?.paymentType === EPaymentType.PREPAYMENT
    : tenantData?.paymentType === EPaymentType.PREPAYMENT;
  const resellerId = supportTenantId ? supportClient?.resellerId : tenantData?.resellerId;

  return hasFeatureFlag || (isPrePaymentType && resellerId === EResellerIds.MFM_ID);
};

const usePayKeeperAutopaymentEnabled = () => {
  const {id: tenantId} = useParams<'id'>();

  const hasViewPermission = usePermission(
    and<EPermission>('PERMISSION_VIEW_PAYKEEPER', 'PERMISSION_VIEW_BILLING'),
  );

  const {data: tenantData} = useGetTenantDataQuery(undefined, {skip: !!tenantId});
  const {data: supportClient} = useGetSupportClientQuery(tenantId ?? skipToken);

  const resellerId = tenantId ? supportClient?.resellerId : tenantData?.resellerId;
  const isSupport = !!tenantId;

  return (isSupport || hasViewPermission) && resellerId === EResellerIds.OSK_ID;
};

export {useStripeAutopaymentEnabled, usePayKeeperAutopaymentEnabled};
